import React from 'react';

import ImportTemplatesShow from '@components/shared/import_templates/ImportTemplatesShow';
import { useLoaderData } from 'react-router-dom';

import { importTemplateService } from '@services/admin/importTemplateService';

export default function ImportTemplateShow() {
  const importTemplate = useLoaderData();

  return (
    <ImportTemplatesShow
      importTemplate={importTemplate}
      importTemplateService={importTemplateService}
      role="admin"
    />
  );
}
